import { action, makeObservable, observable, runInAction } from "mobx";
import agent from "../api/agent";

export default class ScreeningStore {
  rootStore;

  // Dashboard
  dashboardStats = null;
  loadingDashboard = false;

  // Workflow list
  workflows = [];
  myTemplates = [];
  sharedTemplates = [];
  loadingWorkflows = false;

  // Workflow editor
  currentWorkflow = null;
  loadingWorkflow = false;
  savingWorkflow = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      dashboardStats: observable,
      loadingDashboard: observable,
      workflows: observable,
      myTemplates: observable,
      sharedTemplates: observable,
      loadingWorkflows: observable,
      currentWorkflow: observable,
      loadingWorkflow: observable,
      savingWorkflow: observable,

      fetchDashboard: action,
      fetchWorkflows: action,
      fetchWorkflow: action,
      saveWorkflow: action,
      deleteWorkflow: action,
      toggleShare: action,
    });
  }

  // ── Dashboard ──
  fetchDashboard = async (projectId) => {
    this.loadingDashboard = true;
    try {
      const stats = await agent.Screening.dashboard(projectId);
      runInAction(() => {
        this.dashboardStats = stats;
        this.loadingDashboard = false;
      });
    } catch (err) {
      runInAction(() => { this.loadingDashboard = false; });
      console.error("Failed to fetch screening dashboard", err);
    }
  };

  // ── Workflow Lists ──
  fetchWorkflows = async (projectId) => {
    this.loadingWorkflows = true;
    try {
      const [all, mine, shared] = await Promise.all([
        agent.Screening.listWorkflows(projectId),
        agent.Screening.listWorkflows(projectId, false),
        agent.Screening.listWorkflows(projectId, true),
      ]);
      runInAction(() => {
        this.workflows = all || [];
        this.myTemplates = (mine || []).filter((w) => w.isTemplate && !w.isShared);
        this.sharedTemplates = (shared || []).filter((w) => w.isShared);
        this.loadingWorkflows = false;
      });
    } catch (err) {
      runInAction(() => { this.loadingWorkflows = false; });
      console.error("Failed to fetch workflows", err);
    }
  };

  // ── Single Workflow ──
  fetchWorkflow = async (id) => {
    this.loadingWorkflow = true;
    try {
      const workflow = await agent.Screening.getWorkflow(id);
      runInAction(() => {
        this.currentWorkflow = workflow;
        this.loadingWorkflow = false;
      });
    } catch (err) {
      runInAction(() => { this.loadingWorkflow = false; });
      console.error("Failed to fetch workflow", err);
    }
  };

  saveWorkflow = async (data) => {
    this.savingWorkflow = true;
    try {
      await agent.Screening.saveWorkflow(data);
      runInAction(() => { this.savingWorkflow = false; });
      return true;
    } catch (err) {
      runInAction(() => { this.savingWorkflow = false; });
      console.error("Failed to save workflow", err);
      return false;
    }
  };

  deleteWorkflow = async (id) => {
    try {
      await agent.Screening.deleteWorkflow(id);
      return true;
    } catch (err) {
      console.error("Failed to delete workflow", err);
      return false;
    }
  };

  toggleShare = async (id, isShared) => {
    try {
      await agent.Screening.toggleShare(id, isShared);
      return true;
    } catch (err) {
      console.error("Failed to toggle share", err);
      return false;
    }
  };
}
